var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solution-page-container"},[_c('nav-bar',{attrs:{"model":"blue"}}),_vm._v(" "),_c('banner'),_vm._v(" "),_c('solution-content'),_vm._v(" "),_c('partner'),_vm._v(" "),_c('customize'),_vm._v(" "),_c('page-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e35ed36a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/solution/solution.vue
// module id = null
// module chunks = 